module.exports = __webpack_public_path__ + "static/media/11.780cf621.jpg";